import httpClient from './httpClient';

export default {
  completeQuote: user => httpClient.put('/api/insurance/complete', user),
  sendVerificationCode: payload => httpClient.post('/api/insurance/idverify', payload),
  verifyCode: payload => httpClient.put('/api/insurance/idverify', payload),
  resendCode: payload => httpClient.post('/api/insurance/idverify/resend', payload),
};
